import { render, staticRenderFns } from "./tiposDocumentosAdd.vue?vue&type=template&id=29f91896&"
import script from "./tiposDocumentosAdd.vue?vue&type=script&lang=js&"
export * from "./tiposDocumentosAdd.vue?vue&type=script&lang=js&"
import style0 from "./tiposDocumentosAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports